// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type ToolConfig, ToolConfigDaten } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useUpsertToolConfig(): (
  aufgabeId: string,
  toolId: string,
  key: string,
  requestBody: ToolConfigDaten
) => Promise<ToolConfig> {
  const getAPI = useGetApi();
  return useCallback(
    async (aufgabeId, toolId, key, requestBody) =>
      (await getAPI()).tools.upsertToolConfig({
        aufgabeId,
        toolId,
        key,
        requestBody,
      }),
    [getAPI]
  );
}
